<tui-hosted-dropdown [content]="content">
  <tui-avatar
    class="cursor-pointer"
    size="m"
    [style.--tui-avatar-background]="'var(--tui-primary)'"
    [style.--tui-avatar-color]="'white'"
    [text]="userFullName()"
  ></tui-avatar>
</tui-hosted-dropdown>
<ng-template #content>
  <tui-data-list role="menu">
    <tui-opt-group>
      <button routerLink="user" tuiOption>
        {{ 'menu.navigation.account' | transloco }}
      </button>

      <button (click)="logout()" tuiOption>
        {{ 'menu.navigation.logOut' | transloco }}
        <tui-svg src="tuiIconLogOut"></tui-svg>
      </button>
    </tui-opt-group>
  </tui-data-list>
</ng-template>
